/* eslint-disable no-param-reassign */
import { EditorState } from '@candulabs/craft';
import forIn from 'lodash/forIn';

import { unpackShorthandStyles } from 'craft/utils';

export const normalizeCss = (state: EditorState) => {
  forIn(state.nodes, (node) => {
    const { css } = node.data.custom;
    if (!css) {
      node.data.custom.css = {};
      return;
    }
    if (css.padding || css.margin) {
      node.data.custom.css = unpackShorthandStyles(css);
    }
  });
};
